import { useQuery } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import {
  GetPolicyholderDetailsClientRequest,
  GetPolicyholderDetailsClientResponse,
} from '../../@types/PolicyHolderDetails'
import { api } from '../../Services/API'
import { API_ROUTES } from '../../constants/apiRoutes'
import { QUERY_KEYS } from '../../constants/queryKeys'

const request = async (
  policyholderDetails: GetPolicyholderDetailsClientRequest,
) => {
  const { data } = await api.post<GetPolicyholderDetailsClientResponse>(
    API_ROUTES.policyholderDetails,
    policyholderDetails,
  )

  return data
}

export const useGetPolicyholderDetails = (
  policyholderDetails: GetPolicyholderDetailsClientRequest,
  enabled = false,
) => {
  return useQuery<
    GetPolicyholderDetailsClientResponse,
    AxiosError<ErrorHandling[]>
  >({
    queryKey: [QUERY_KEYS.policyholderDetails, policyholderDetails],
    queryFn: () => request(policyholderDetails),
    enabled,
  })
}
